import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";

function formatPoints(points, close) {
  points = _toConsumableArray(points); // so that coords can be passed as objects or arrays

  if (!Array.isArray(points[0])) {
    points = points.map(function (_ref) {
      var x = _ref.x,
          y = _ref.y;
      return [x, y];
    });
  }

  if (close) {
    var lastPoint = points[points.length - 1];
    var secondToLastPoint = points[points.length - 2];
    var firstPoint = points[0];
    var secondPoint = points[1];
    points.unshift(lastPoint);
    points.unshift(secondToLastPoint);
    points.push(firstPoint);
    points.push(secondPoint);
  }

  return points.flat();
}

function spline() {
  var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var tension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var close = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var cb = arguments.length > 3 ? arguments[3] : undefined;
  points = formatPoints(points, close);
  var size = points.length;
  var last = size - 4;
  var startPointX = close ? points[2] : points[0];
  var startPointY = close ? points[3] : points[1];
  var path = "M" + [startPointX, startPointY];
  cb && cb("MOVE", [startPointX, startPointY]);
  var startIteration = close ? 2 : 0;
  var maxIteration = close ? size - 4 : size - 2;
  var inc = 2;

  for (var i = startIteration; i < maxIteration; i += inc) {
    var x0 = i ? points[i - 2] : points[0];
    var y0 = i ? points[i - 1] : points[1];
    var x1 = points[i + 0];
    var y1 = points[i + 1];
    var x2 = points[i + 2];
    var y2 = points[i + 3];
    var x3 = i !== last ? points[i + 4] : x2;
    var y3 = i !== last ? points[i + 5] : y2;
    var cp1x = x1 + (x2 - x0) / 6 * tension;
    var cp1y = y1 + (y2 - y0) / 6 * tension;
    var cp2x = x2 - (x3 - x1) / 6 * tension;
    var cp2y = y2 - (y3 - y1) / 6 * tension;
    path += "C" + [cp1x, cp1y, cp2x, cp2y, x2, y2];
    cb && cb("CURVE", [cp1x, cp1y, cp2x, cp2y, x2, y2]);
  }

  return path;
}

export { spline };